import { Carrousel, Contacto, Presentation } from "./components";

export default function Home() {
  return (
    <div className="overflow-hidden">
      <Presentation />
      <Carrousel />
      <Contacto />
    </div>
  );
}
